import { useEffect, useState } from 'react';
import { Grid, Typography, useTheme, useMediaQuery, Box } from '@mui/material';
import MapContainer from '@shared/components/MapContainer';
import TDHlogo from '@shared/assets/customMarkerTDH.png';

import { getSubsidiariesNew } from '@shared/services/services';
import DialogMapModal from '@shared/components/Dialogs/Map';
import { orderByName } from '@shared/helpers';
import { useSelector } from 'react-redux';

import SubsidiariesList from './SubsidiariesList';

const SellPoints = () => {
  const [sucLatLong, setSucLatLong] = useState({
    lat: -31.407944,
    lng: -64.190279,
  });
  const [showModalDialog, setShowModalDialog] = useState(false);
  const [showModalDialogTitle, setShowModalDialogTitle] = useState('');
  const [sucursales, setSucursales] = useState([]);
  const [sucursalesFiltered, setSucursalesFiltered] = useState([]);
  const [textFilter, setTextFilter] = useState('');
  const [selectedSuc, setSelectedSuc] = useState(null);

  const { name } = useSelector(store => store.pageConfiguration);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    const fetchSubsidiaries = async () => {
      let result = await getSubsidiariesNew();
      result = result.data.filter(el => el.status.name !== 'inactive');
      result = orderByName(result);
      setSucursales(result);
      setSucursalesFiltered(result);
    };
    fetchSubsidiaries();
  }, []);

  const handleTextChange = e => {
    const value = e.target.value;
    setTextFilter(value);

    setSucursalesFiltered(
      sucursales.filter(suc =>
        suc.name
          .replace(name + '- ', '')
          .toUpperCase()
          .includes(value.toUpperCase())
      )
    );
  };

  const parseLatLng = (lat, lng) => {
    const latNum = Number(lat);
    const lngNum = Number(lng);

    if (!isFinite(latNum) || !isFinite(lngNum)) {
      console.error('Lat o Lng inválidos:', lat, lng);
      return null;
    }
    return { lat: latNum, lng: lngNum };
  };

  // Cambiar sucursal
  const changeSuc = (name, lat, lng) => {
    const newSuc = parseLatLng(lat, lng);
    if (!newSuc) {
      return;
    }

    setSelectedSuc({ name, latLng: newSuc });

    if (!isMdUp) {
      setShowModalDialog(true);
    }
  };

  // Efecto para actualizar mapa y título
  useEffect(() => {
    if (!selectedSuc) {
      return;
    }

    setShowModalDialogTitle(selectedSuc.name);
    setSucLatLong(selectedSuc.latLng);
  }, [selectedSuc]);

  // Click en marker
  const markerClick = marker => {
    const lat = Number(marker.latitude);
    const lng = Number(marker.longitude);
    if (!isFinite(lat) || !isFinite(lng)) return;

    setSelectedSuc({ name: marker.name, latLng: { lat, lng } });
  };

  const validMarkers = sucursales
    .map(s => {
      const lat = Number(s.latitude);
      const lng = Number(s.longitude);
      if (!isFinite(lat) || !isFinite(lng)) return null;
      return { ...s, latitude: lat, longitude: lng };
    })
    .filter(Boolean);

  return (
    <Grid
      container
      className="minWebPadding"
      sx={{ backgroundColor: '#E5E5E5', py: 2 }}
    >
      <Grid item container direction="column">
        <Grid container direction="row" style={{ marginBottom: 25 }}>
          <div
            style={{
              width: 8,
              backgroundColor: theme.primary,
              marginRight: 5,
            }}
          />
          <Typography
            variant="h4"
            fontSize={'bold'}
            style={{ marginBottom: '10px', fontWeight: 'bold', color: 'black' }}
          >
            {'Puntos de Venta'}
          </Typography>
        </Grid>

        <Grid item container direction="row">
          <Grid item container xs={12} sm={4}>
            <SubsidiariesList
              sucursalesFiltered={sucursalesFiltered}
              textFilter={textFilter}
              handleTextChange={handleTextChange}
              changeSuc={changeSuc}
              name={name}
            />
          </Grid>

          <Grid
            item
            container
            xs={12}
            sm={8}
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            <Box
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                marginTop: { xs: '35px', md: 0 },
              }}
            >
              <MapContainer
                center={sucLatLong}
                multipleMarkers={validMarkers}
                customMarker={TDHlogo}
                zoom={selectedSuc ? 16 : 12}
                onMarkerClick={markerClick}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <DialogMapModal
        isOpen={showModalDialog}
        onClose={() => setShowModalDialog(false)}
        title={showModalDialogTitle}
      >
        {showModalDialog && (
          <MapContainer center={sucLatLong} customMarker={TDHlogo} />
        )}
      </DialogMapModal>
    </Grid>
  );
};

export default SellPoints;
